export enum accidentStatuses {
  NEW = "new",
  CONFIRMED = "confirmed",
  REJECTED = "rejected",
  COMPLETED = "completed",
  DELETED = "deleted",
}